<script setup>
// import { ref } from 'vue';
import BlockKerjaTable from "./Tables/BlockKerjaTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import CustomComboBox from "@/components/Custom_DDL_Checkbox.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<style>
  .form-check-input {
    transform: scale(1.5); /* Adjust the scale factor as needed */
    width: 20px; /* Optional: Set a specific width */
    height: 20px; /* Optional: Set a specific height */
  }

</style>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Kerja</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Block Id</label>
                            
                            <CustomComboBox :list="blockidList" v-model="kerja.blockid"/>
                            <!-- <select class="form-control" v-model="kerja.blockid">
                                <option v-for="(item,index) in blockidList" :key="index" :value="item.blockid">
                                    {{ item.blockid }} - {{ item.blockname }} - {{ item.remark }}
                                </option>
                            </select> -->
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label text-danger">Kerja (Atleast satu)</label>
                            <div class="d-flex flex-wrap">
                                <div class="form-check form-check-inline">
                                    <input  type="checkbox" value="Cuci Daun" id="chk_cuci" v-model="selectedKerja" />
                                    <label class="form-check-label" for="chk_cuci">Cuci Daun</label>
                                </div>
                                <!-- <div class="form-check form-check-inline">
                                    <input  type="checkbox" value="Baja" id="chk_baja" v-model="selectedKerja" />
                                    <label class="form-check-label" for="chk_baja">Baja</label>
                                </div> -->
                                <div class="form-check form-check-inline">
                                    <input  type="checkbox" value="Racun" id="chk_racun" v-model="selectedKerja" />
                                    <label class="form-check-label" for="chk_racun">Racun</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input  type="checkbox" value="Others" id="chk_others" v-model="selectedKerja" />
                                    <label class="form-check-label" for="chk_others">Others</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2" >
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input type="date" id="input_date" v-model="kerja.date" class="form-control" >
                        </div>
                        <div class="col-md-2" v-show="selectedKerja.includes('Cuci Daun')">
                            <label for="example-text-input" class="form-control-label text-danger">Cuci (RM)</label>
                            <input type="number" id="input_date" v-model="kerja.cucicost" class="form-control" >
                        </div>
                        <div class="col-md-2" v-show="selectedKerja.includes('Baja')">
                            <label for="example-text-input" class="form-control-label text-danger">Baja (RM)</label>
                            <input type="number" id="input_date" v-model="kerja.bajacost" class="form-control" >
                        </div>
                        <div class="col-md-2" v-show="selectedKerja.includes('Racun')">
                            <label for="example-text-input" class="form-control-label text-danger">Racun (RM)</label>
                            <input type="number" id="input_date" v-model="kerja.racuncost" class="form-control" >
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Labor (RM)</label>
                            <input type="number" id="input_date" v-model="kerja.laborcost" class="form-control" >
                        </div>
                        <div class="col-md-2" v-show="selectedKerja.includes('Others')">
                            <label for="example-text-input" class="form-control-label text-danger">Others (RM)</label>
                            <input type="number" id="input_date" v-model="kerja.othercost" class="form-control" >
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="kerja.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addKerja" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <BlockKerjaTable :key="componentKey" />
        </div>
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'kerjaCreate',
  data(){
    return {
        componentKey: 0,
    //   errorList: '',
        kerja:{
            blockid: '',
            bajacost:'0',
            date: new Date().toISOString().slice(0,10),
            remark:'',
            laborcost:0,
            racuncost:0,
            cucicost:0,
            othercost:0,
            blockkerja:''
        },
        blockidList:[],
        selectedKerja:[]
    }
  },
  mounted(){
    this.getBlockidList();
  },
  methods: {
    getBlockidList(){
        this.blockidList = [];
        axios.get('block/getBlockidList')
            .then(res => {
            
                res.data.blockidList.forEach(element => {
                var blockObj = {
                    "text": element.blockid, "value":element.blockname
                }
                this.blockidList.push(blockObj);
                
              });
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    addKerja(){
        this.kerja.blockkerja = this.selectedKerja.join(", ");
        axios.post('block/addBlockKerja',this.kerja)
            .then(res => {
                alert(res.data.message);

                this.kerja.blockid='';
                this.kerja.bajacost=0;
                this.kerja.date= new Date().toISOString().slice(0,10);
                this.kerja.remark='';
                this.kerja.laborcost=0;
                this.kerja.racuncost=0;
                this.kerja.cucicost=0;
                this.kerja.othercost=0;
                this.kerja.blockkerja='';
                this.selectedKerja = [];

                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: blockid, kerja, date, laborcost, racuncost, cucicost, bajacost, and othercost is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>
